import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {};

export const content: SxStyle = {
  display: 'flex',
  flexDirection: 'column',
  gap: (p) => p.spacing(1.5),
};

export const EmptyIconWrapper: SxStyle = {
  borderRadius: (p) => p.spacing(2),
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: (p) => p.palette.grey[300],
  padding: (p) => p.spacing(1.5),
};
